import { useState } from 'react';
import axios from 'axios';

export default function AdminManagement() {
  const [addForm, setAddForm] = useState({ username: '', password: '' });
  const [changeForm, setChangeForm] = useState({ username: '', newPassword: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleAddAdmin = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/admin/add`,
        addForm,
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      );
      setSuccess('Admin added successfully');
      setAddForm({ username: '', password: '' });
      setError('');
    } catch (err) {
      setError('Failed to add admin: ' + (err.response?.data?.error || err.message));
      setSuccess('');
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/admin/change-password`,
        changeForm,
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      );
      setSuccess('Password changed successfully');
      setChangeForm({ username: '', newPassword: '' });
      setError('');
    } catch (err) {
      setError('Failed to change password: ' + (err.response?.data?.error || err.message));
      setSuccess('');
    }
  };

  return (
    <div className="p-8 bg-white rounded-lg shadow-md max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold mb-4 font-fairplay text-black">Admin Management</h2>
      {error && <p className="text-red-600 mb-4">{error}</p>}
      {success && <p className="text-green-600 mb-4">{success}</p>}
      
      <div className="mb-8">
        <h3 className="text-xl font-bold mb-2 font-fairplay">Add New Admin</h3>
        <form onSubmit={handleAddAdmin} className="space-y-4">
          <input
            type="text"
            value={addForm.username}
            onChange={(e) => setAddForm({ ...addForm, username: e.target.value })}
            placeholder="Username"
            required
            className="w-full p-2 text-black rounded border border-gray-300 font-fairplay"
          />
          <input
            type="password"
            value={addForm.password}
            onChange={(e) => setAddForm({ ...addForm, password: e.target.value })}
            placeholder="Password"
            required
            className="w-full p-2 text-black rounded border border-gray-300 font-fairplay"
          />
          <button
            type="submit"
            className="bg-white text-black px-4 py-2 rounded border border-cyan hover:border-magenta hover:scale-105 transition-all shadow-sm font-fairplay"
          >
            Add Admin
          </button>
        </form>
      </div>

      <div>
        <h3 className="text-xl font-bold mb-2 font-fairplay">Change Admin Password</h3>
        <form onSubmit={handleChangePassword} className="space-y-4">
          <input
            type="text"
            value={changeForm.username}
            onChange={(e) => setChangeForm({ ...changeForm, username: e.target.value })}
            placeholder="Username"
            required
            className="w-full p-2 text-black rounded border border-gray-300 font-fairplay"
          />
          <input
            type="password"
            value={changeForm.newPassword}
            onChange={(e) => setChangeForm({ ...changeForm, newPassword: e.target.value })}
            placeholder="New Password"
            required
            className="w-full p-2 text-black rounded border border-gray-300 font-fairplay"
          />
          <button
            type="submit"
            className="bg-white text-black px-4 py-2 rounded border border-cyan hover:border-magenta hover:scale-105 transition-all shadow-sm font-fairplay"
          >
            Change Password
          </button>
        </form>
      </div>
    </div>
  );
}